import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

const HERO_ITEMS_DESKTOP_MQ = '(min-width: 1200px)'
/** Сколько «ячеек» span=1 помещается по ширине трека при длинном ряду (n > 4). */
const HERO_ITEMS_VIEWPORT_COLS = 4

function readHeroItemsSlideSpan(slide) {
  const raw = slide.getAttribute('data-hero-items-span')
  let v = parseInt(raw ?? '1', 10)
  if (!Number.isFinite(v)) {
    v = 1
  }
  return Math.min(4, Math.max(1, v))
}

function clearHeroItemsSlideInlineWidths(swiper) {
  swiper.el
    .querySelectorAll('.swiper-slide.hero-items__slide')
    .forEach((slide) => {
      slide.style.width = ''
    })
}

function getVisibleGapsForViewport(slides, maxCols) {
  let usedCols = 0
  let visibleSlides = 0

  for (const slide of slides) {
    const span = readHeroItemsSlideSpan(slide)
    if (visibleSlides > 0 && usedCols + span > maxCols) {
      break
    }
    usedCols += span
    visibleSlides += 1
    if (usedCols >= maxCols) {
      break
    }
  }

  return Math.max(0, visibleSlides - 1)
}

function setHeroItemsSlideWidthVars(swiper) {
  const gap =
    typeof swiper.params.spaceBetween === 'number'
      ? swiper.params.spaceBetween
      : 20

  const slides = swiper.el.querySelectorAll('.swiper-slide.hero-items__slide')
  const n = slides.length

  if (!window.matchMedia(HERO_ITEMS_DESKTOP_MQ).matches) {
    swiper.el.style.removeProperty('--hero-items-slide-unit')
    clearHeroItemsSlideInlineWidths(swiper)
    return
  }

  // Небольшой запас на субпиксель/скругления, чтобы не просвечивал следующий слайд.
  const slackTrack = 3
  const trackPx = Math.max(
    0,
    Math.floor(swiper.el.getBoundingClientRect().width) - slackTrack,
  )

  clearHeroItemsSlideInlineWidths(swiper)

  let sumSpan = 0
  slides.forEach((slide) => {
    sumSpan += readHeroItemsSlideSpan(slide)
  })
  if (sumSpan <= 0) {
    sumSpan = n || 1
  }

  let unitPx
  if (n > HERO_ITEMS_VIEWPORT_COLS) {
    const gapsInViewport = getVisibleGapsForViewport(
      slides,
      HERO_ITEMS_VIEWPORT_COLS,
    ) * gap
    unitPx =
      (trackPx - gapsInViewport) / HERO_ITEMS_VIEWPORT_COLS
  } else {
    const gapTotal = Math.max(0, n - 1) * gap
    unitPx = (trackPx - gapTotal) / sumSpan
  }

  if (!Number.isFinite(unitPx) || unitPx < 0) {
    unitPx = 0
  }

  swiper.el.style.setProperty(
    '--hero-items-slide-unit',
    `${Math.floor(unitPx * 1000) / 1000}px`,
  )
}

export function initHeroItemsSwiper() {
  const el = document.querySelector('[data-hero-items-swiper]')
  if (!el) {
    return
  }
  const root = el.closest('.hero-items')
  const prevEl = root?.querySelector('[data-hero-items-prev]')
  const nextEl = root?.querySelector('[data-hero-items-next]')

  const swiper = new Swiper(el, {
    modules: [Navigation],
    watchOverflow: true,
    speed: 450,
    spaceBetween: 12,
    slidesPerView: 1.2,
    navigation:
      prevEl && nextEl
        ? {
            prevEl,
            nextEl,
          }
        : undefined,
    breakpoints: {
      576: {
        slidesPerView: 2.1,
        spaceBetween: 14,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 18,
      },
      1200: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        allowTouchMove: false,
      },
    },
    on: {
      init(s) {
        setHeroItemsSlideWidthVars(s)
      },
      breakpoint(s) {
        setHeroItemsSlideWidthVars(s)
      },
    },
  })

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setHeroItemsSlideWidthVars(swiper)
    })
  })

  let resizeTimer
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer)
    resizeTimer = window.setTimeout(() => {
      setHeroItemsSlideWidthVars(swiper)
    }, 120)
  })

  root?.querySelectorAll('.hero-items__video').forEach((video) => {
    if (video instanceof HTMLVideoElement) {
      video.play().catch(() => {})
    }
  })
}
